module.exports = __webpack_public_path__ + "static/media/HCMM012.a4217ab3.jpg";